import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import BD_01 from './../../../img/BD_01.png';
import BD_02 from './../../../img/BD_02.png';
import BD_03 from './../../../img/BD_03.png';
import BD_04 from './../../../img/BD_04.png';
import BD_05 from './../../../img/BD_05.png';
import BD_06 from './../../../img/BD_06.png';
import AccionesComunes from '../../AccionesComunes';

class BaseDatos extends Component {

    componentDidMount(){
       var activeMenu = document.getElementById("conoceSIJE");
       activeMenu.classList.add("active");
    }

    render () {
        return (
            <div className="container contenido">
                <AccionesComunes />
                <div className="migajas">
                    <small>
                        <Link to="./QueEsSIJE">Inicio</Link>
                        <span>Conoce el SIJE</span>
                        <span>Base de Datos</span>
                    </small>
                </div>
                <div className="col-md-12 text-center">
                    <h1 className="tituloPagina">Base de datos</h1>
                    <p className="centrar">
                        La base de datos descomprimida contiene los siguientes archivos:
                    </p>
                    <ul className="listaArchivosBD mb-5">
                        <li>01_INSTALACION_CASILLAS</li>
                        <li>02_SEGUNDO_REPORTE</li>
                    </ul>

                    {/* <div className="termino col-md-12">
                    <p><a href="src/materiales/SIJE_19-06-2020 17.50.00.zip" target="_blank" rel="noopener noreferrer">Descargar Bases de datos</a></p>
                </div> */}

                    <p className="centrar">
                        Para la correcta visualización de la base de datos, es necesario que realices el siguiente procedimiento:
                    </p>
                </div>
                <div className="row bordes">
                    <div className="col-md-12 centrar-vertical">
                        <div className="numerales">
                            <p>1</p>
                        </div>
                        <div>
                            <p>
                                Abre Microsoft Excel, y en un documento en blanco ubica y presiona la pestaña <strong><i>“Datos”</i></strong>.
                            </p>
                        </div>
                    </div>
                    <div className="col-md-12">
                        <img src={BD_01} alt="Excel pestaña datos" />
                    </div>
                </div>

                <div className="row bordes">
                    <div className="col-md-12 centrar-vertical">
                        <div className="numerales">
                            <p>2</p>
                        </div>
                        <div>
                            <p>
                                En la pestaña “Datos”, ubica y presiona la opción <strong><i>“Desde texto”</i></strong>.
                            </p>
                        </div>
                    </div>
                    <div className="col-md-12">
                        <img src={BD_02} alt="desde texto" />
                    </div>
                </div>

                <div className="row bordes">
                    <div className="col-md-12 centrar-vertical">
                        <div className="numerales">
                            <p>3</p>
                        </div>
                        <div>
                            <p>
                                Se abre una ventana del explorador de archivos, ubica la carpeta descomprimida que contiene los archivos que descargaste. Selecciona el documento que deseas consultar y presiona <strong><i>“Abrir”</i></strong>.
                            </p>
                        </div>
                    </div>
                    <div className="col-md-12">
                        <img src={BD_03} alt="abre el archivo" />
                    </div>
                </div>

                <div className="row bordes">
                    <div className="col-md-12 centrar-vertical">
                        <div className="numerales">
                            <p>4</p>
                        </div>
                        <div>
                            <p>
                                Al hacerlo se muestra el “Asistente para importar texto”, En la ventana del paso uno, debes activar la opción <strong><i>“Delimitados”</i></strong>, así como seleccionar la opción <strong><i>"Unicode (UTF-8)"</i></strong> en “Origen del archivo".
                            </p>
                            <p>
                                Una vez hecho presiona <strong><i>“Siguiente”</i></strong>.
                            </p>
                        </div>
                    </div>
                    <div className="col-md-12">
                        <img src={BD_04} alt="Asistente para importar texto 1" />
                    </div>
                </div>

                <div className="row bordes">
                    <div className="col-md-12 centrar-vertical">
                        <div className="numerales">
                            <p>5</p>
                        </div>
                        <div>
                            <p>
                                En la ventana del paso dos, únicamente debe estar activa la casilla de verificación <strong><i>“Otro”</i></strong>. Frente a dicha casilla se muestra un campo, captura el carácter pipe “|” y presiona <strong><i>“Siguiente”</i></strong>.
                            </p>
                        </div>
                    </div>
                    <div className="col-md-12">
                        <img src={BD_05} alt="Asistente para importar texto 2" />
                    </div>
                </div>

                <div className="row bordes">
                    <div className="col-md-12 centrar-vertical">
                        <div className="numerales">
                            <p>6</p>
                        </div>
                        <div>
                            <p>
                                Para asegurar que los datos se muestren correctamente, debes asegurarte que el formato de la columna “CLAVE_CASILLA” sea texto.</p>
                            <p>
                                Haz clic en la columna, y después activa la opción <strong><i>“Texto”</i></strong>. Una vez cambiado el formato presiona <strong><i>“Finalizar”</i></strong>.
                            </p>
                        </div>
                    </div>
                    <div className="col-md-12">
                        <img src={BD_06} alt="Asistente para importar texto 3" />
                    </div>
                </div>
            </div>
        )
    }
}

export default BaseDatos;